import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {shallowEqual, useSelector} from 'react-redux';

const OrderStatus = ({
                       variant,
                       size,
                       statusID,
                       customClassNames,
                     }) => {

  const {statusList} = useSelector(
    (state) => ({
      statusList: state.statusListReducer.statusList,
    }),
    shallowEqual
  );
  const getStatusName = (statusID) => {
    let filteredArray = statusList.filter(status => status.value === statusID);

    return filteredArray.length > 0 ? filteredArray[0].label : '';
  };
  const getTextSize = (size) => {
    switch (size) {
      case 'sm':
        return 'font-size-h7';
      case 'm':
        return 'font-size-h6';
      case 'xl':
        return 'font-size-h2';
      case 'lg':
      default:
        return 'font-size-h4';
    }
  };
  const getColor = (statusID) => {
    switch (statusID) {
      case 1:
        return {
          background: '#E3F0FB',
          border: '1px solid rgb(56, 189, 248)',
          color: 'rgb(56, 189, 248)'
        };
      case 2:
        return {
          background: '#F9F4E5',
          border: '1px solid rgb(253, 185, 19)',
          color: 'rgb(253, 185, 19)'
        };
      case 3:
        return {
          background: '#CDEADB',
          border: '1px solid rgb(65, 141, 88)',
          color: 'rgb(65, 141, 88)'
        };
      case 4:
        return {
          background: 'rgb(233, 236, 236)',
          border: '1px solid rgb(82, 94, 96)',
          color: 'rgb(82, 94, 96)'
        };
      default:
        return null;
    }
  };

  switch (variant) {
    case 'badge':
      return (
        <div
          className={classnames(
            'badge badge-pill text-nowrap',
            getTextSize(size),
            customClassNames,
          )}
          style={getColor(statusID)}
        >
          {getStatusName(statusID)}
        </div>
      );
    default:
      return (
        <div
          className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap"
        >
          {getStatusName(statusID)}
        </div>
      );
  }


};

OrderStatus.propTypes = {
  statusID: PropTypes.number,
  customClassNames: PropTypes.string
};

export default OrderStatus;
